import React from 'react'
import classNames from 'classnames'
import { SlotWrapper, type ReservationSlotProps } from '@pandiafi/components'

import styles from './ResidentAppSlot.module.css'

export type ResidentAppTimeSlotType = 'own' | 'free' | 'reserved'

interface ResidentAppSlotProps extends ReservationSlotProps {
  startTime: string
  endTime: string
  slotType: ResidentAppTimeSlotType
  onClick?: () => void
  single?: boolean
  selected?: boolean
  additionalDetails?: string
  hideTime?: boolean
}

export const ResidentAppSlot: React.FC<ResidentAppSlotProps> = (props) => {
  const {
    startTime,
    slotType,
    single = false,
    onClick,
    selected,
    additionalDetails,
    hideTime = false,
    ...otherProps
  } = props

  const mappedSlotType =
    slotType === 'free' ? 'free' : slotType === 'own' ? 'free' : 'disabled'

  return (
    <SlotWrapper
      startTime={startTime}
      type={mappedSlotType}
      onClick={onClick}
      {...otherProps}
    >
      <div
        className={classNames(styles.slot, {
          [styles.free]: slotType === 'free',
          [styles.own]: slotType === 'own',
          [styles.disabled]: slotType === 'reserved',
          [styles.selected]: selected,
        })}
      >
        {!hideTime &&
          mappedSlotType !== 'disabled' &&
          (single ? (
            <div className={styles.singleWrapper}>
              <div className={styles.singleBadgeWrapper}>
                <span className={styles.singleBadge}>1</span>
              </div>
              <div>{startTime}</div>
            </div>
          ) : (
            <div>{startTime}</div>
          ))}
        {additionalDetails ? (
          <>
            <div className={styles.detailsTime}>{startTime}</div>
            <div className={styles.detailsText}>{additionalDetails}</div>
          </>
        ) : null}
      </div>
    </SlotWrapper>
  )
}
